module.exports = __webpack_public_path__ + "img/icon-light-user-white.b2c36f31.svg";